module.exports = __webpack_public_path__ + "static/img/WebOp@2x.ac6baac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/WebOp@2x.png
// module id = CZQ+
// module chunks = 0